import { WinFormsContentScreen } from '@winforms';
import { __asyncI18n } from '@localisation';
import { RoutingEntry } from '@routing';
import { DummySiteComponent } from '@site-info';

export const TenantRoutes: Array<RoutingEntry> = [
     {
        path : '',
        component: WinFormsContentScreen,
        data: {
            title: __asyncI18n('Tenants', 'subnavi.administration.tenants'),
            contentRoute : '/SystemAdministration/Tenant/List',
            showSubNaviLevel: 1
        }
    },
    {
        path : 'Add',
        component: WinFormsContentScreen,
        data : {
            title : __asyncI18n('Add tenant', 'subnavi.administration.add-tenat'),
            contentRoute : '/SystemAdministration/Tenant/Settings/',
            showSubNaviLevel: 1
        }
    },
    {
        path : 'AddSub/:parentId',
        component: WinFormsContentScreen,
        data : {
            title : __asyncI18n('Add sub-tenant', 'subnavi.administration.add-sub-tenat'),
            contentRoute : '/SystemAdministration/Tenant/Settings?parentId=:parentId',
            showSubNaviLevel: 1
        }
    },
    {
        path : 'CreateFromTemplate',
        component : WinFormsContentScreen,
        data : {
            title : __asyncI18n('Create from template', 'subnavi.administration.create-tenant-from-template'),
            contentRoute : '/SystemAdministration/Tenant/CreateTenantFromTemplate?parentId=:parentId',
            showSubNaviLevel: 1
        }
    },
    {
        path : ':selectedtenantid',
        data : {
            title : ':selectedtenantid | tenantIdToName',
            showSubNaviLevel: 1,
            redirectTo : '/Administration/Tenants/:selectedtenantid/Settings',
            favouritesRouteCaption: '[MainPageName]'
        },
        children : [
            {
                path : '',
                component : DummySiteComponent,
                data : {
                    title : ':selectedtenantid | tenantIdToName',
                    showSubNaviLevel: 1,
                    redirectTo : '/Administration/Tenants/:selectedtenantid/Settings'
                }
            },
            {
                path : 'Settings',
                component: WinFormsContentScreen,
                data : {
                    title : ':selectedtenantid | tenantIdToName',
                    showSubNaviLevel: 1,
                    contentRoute : '/SystemAdministration/Tenant/Settings/:selectedtenantid',
                    dontShowInBreadCrumb : true,
                    favouritesTitle: '[ParentParentPageName]'
                }
            }
        ]
    }
];
